export type Upgrade = {
    version: string;
    apply: (project: any) => any;
};

export const upgrade = <T>(project: T, { allUpgrades }: { allUpgrades: Upgrade[] }): T => {

    for (const upgrade of pendingUpgradesFor(project, allUpgrades)) {
        project = upgrade.apply(project);
    }

    return project as T;
};

const pendingUpgradesFor = (project: any, allUpgrades: Upgrade[]) => {

    if (!project.version) {
        return allUpgrades;
    }

    const currentIndex = allUpgrades.findIndex(u => u.version === project.version);

    if (currentIndex === -1) {
        return allUpgrades;
    } else {
        return allUpgrades.slice(currentIndex + 1);
    }
};